/* Product page (PDP): variant picker, gallery, add to cart, back-in-stock, scroll freeze. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var dataEl = root.querySelector('[data-pdp-json]');
  var form = root.querySelector('[data-pdp-form]');
  if (!dataEl || !form) return;

  var data = JSON.parse(dataEl.textContent);
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-option]'));
  var idInput = form.querySelector('[data-pdp-variant-id]');
  var addBtn = form.querySelector('[data-pdp-add]');
  var errorEl = form.querySelector('[data-pdp-error]');
  var priceEl = root.querySelector('[data-pdp-price]');
  var notify = root.querySelector('[data-pdp-notify]');
  var soldOutBadge = root.querySelector('[data-pdp-soldout]');
  var cartIds = {};

  /* ---------- Variant selection ---------- */

  function selectedOptions() {
    return groups.map(function (group) {
      var checked = group.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  // Lookup by joined option values: refreshValues() calls this once per value on every change.
  var variantMap = {};
  data.variants.forEach(function (variant) { variantMap[variant.options.join('\u0000')] = variant; });

  function findVariant(options) {
    if (!groups.length) return data.variants[0];
    return variantMap[options.join('\u0000')] || null;
  }

  // Mark every value against the other current selections. Nothing is hidden or auto-changed:
  // picking a size never resets the leg length (CU item 5).
  function refreshValues(options) {
    groups.forEach(function (group, groupIndex) {
      group.querySelectorAll('input').forEach(function (input) {
        var trial = options.slice();
        trial[groupIndex] = input.value;
        var variant = findVariant(trial);
        var label = input.closest('.pdp-value');
        label.classList.toggle('is-unavailable', !variant);
        label.classList.toggle('is-soldout', !!variant && !variant.available);
        // Same state for screen readers (the strike-through / grey is visual only).
        var state = label.querySelector('[data-pdp-value-state]');
        if (state) state.textContent = !variant ? ', unavailable' : (!variant.available ? ', sold out' : '');
        if (data.clearance) input.disabled = !variant || !variant.available;
      });
      var valueOut = group.querySelector('[data-pdp-option-value]');
      if (valueOut) valueOut.textContent = options[groupIndex] || '';
    });
  }

  function renderPrice(variant) {
    if (!priceEl) return;
    priceEl.textContent = '';
    if (variant.compare) {
      var sale = document.createElement('span');
      sale.className = 'pdp-price__sale';
      sale.textContent = variant.price;
      var rrp = document.createElement('s');
      rrp.className = 'pdp-price__rrp';
      rrp.textContent = 'RRP ' + variant.compare;
      priceEl.append(sale, ' ', rrp);
    } else {
      var regular = document.createElement('span');
      regular.className = 'pdp-price__regular';
      regular.textContent = 'RRP ' + variant.price;
      priceEl.append(regular);
    }
  }

  function setButton(variant) {
    addBtn.classList.remove('addedCart');
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    } else if (!variant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
    } else if (cartIds[variant.id]) {
      addBtn.disabled = false;
      addBtn.textContent = 'View cart';
      addBtn.classList.add('addedCart');
    } else {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
    }
  }

  function update(fromUser) {
    var options = selectedOptions();
    var variant = findVariant(options);
    refreshValues(options);
    setButton(variant);
    [errorEl, stickyError].forEach(function (el) { if (el) el.hidden = true; });
    if (notify) notify.hidden = !variant || variant.available;
    if (soldOutBadge) soldOutBadge.hidden = !variant || variant.available;
    if (sticky) updateStickyVariant(options, variant);
    if (!variant) return;
    if (notifyDoneFor && notifyDoneFor !== String(variant.id)) resetNotify();

    idInput.value = variant.id;
    renderPrice(variant);
    if (variant.media) showMedia(variant.media);

    // Keep the selection in the URL so Back restores it (CU item 13).
    if (fromUser && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url.toString());
    }
  }

  groups.forEach(function (group) {
    group.addEventListener('change', function () { update(true); });
  });

  /* ---------- Gallery ---------- */

  var gallery = root.querySelector('[data-pdp-gallery]');
  var list = gallery && gallery.querySelector('[data-pdp-gallery-list]');
  var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.pdp-gallery__thumb')) : [];
  var mobile = window.matchMedia('(max-width: 991px)');

  function setSizes(item, sizes) {
    var img = item && item.querySelector('img');
    if (img && sizes) img.setAttribute('sizes', sizes);
  }

  function itemFor(mediaId) {
    return list ? list.querySelector('[data-media-id="' + mediaId + '"]') : null;
  }

  function scrollToItem(item) {
    if (!item || !mobile.matches) return;
    list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
  }

  // The selected variant's image becomes the lead (large) image.
  function showMedia(mediaId) {
    var item = itemFor(mediaId);
    if (!item) return;
    var lead = list.firstElementChild;
    if (item !== lead) {
      setSizes(lead, gallery.dataset.sizesGrid);
      list.insertBefore(item, lead);
      setSizes(item, gallery.dataset.sizesLead);
    }
    if (mobile.matches) list.scrollTo({ left: 0 });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      scrollToItem(itemFor(thumb.dataset.mediaId));
    });
  });

  if (list && thumbs.length) {
    var ticking = false;
    list.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var index = Math.round(list.scrollLeft / Math.max(list.clientWidth, 1));
        var current = list.children[index];
        var id = current && current.dataset.mediaId;
        thumbs.forEach(function (thumb) { thumb.classList.toggle('is-active', thumb.dataset.mediaId === id); });
      });
    }, { passive: true });
  }

  if (window.LuminousGallery && list) {
    new window.LuminousGallery(list.querySelectorAll('.luminous-lightbox'));
  }

  /* ---------- Add to cart ---------- */

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
  }

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (response) { return response.json(); })
    .then(function (cart) {
      cart.items.forEach(function (item) { cartIds[item.variant_id] = true; });
      update(false);
    })
    .catch(function () { /* cart state is a nicety; the button still works */ });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (addBtn.classList.contains('addedCart')) {
      window.location.href = '/cart';
      return;
    }
    addBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        // A 5xx or 429 can come back as HTML, so a parse failure must not surface as the error text.
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok || !body.variant_id) {
            var error = new Error('Add to cart failed (' + response.status + ')');
            error.shopperMessage = body.description; // Shopify's 422 text, e.g. "All 2 ... are in your cart."
            throw error;
          }
          return body;
        });
      })
      .then(function (item) {
        cartIds[item.variant_id] = true;
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        update(false);
        if (typeof window.getUpsell === 'function') window.getUpsell();
      })
      .catch(function (error) {
        update(false);
        // Also on the sticky bar: when it was used, the main form's message is off screen.
        var message = error.shopperMessage || 'Sorry, we couldn’t add that to your cart. Please try again.';
        [errorEl, stickyError].forEach(function (el) {
          if (!el) return;
          el.textContent = message;
          el.hidden = false;
        });
      });
  });

  /* ---------- Sticky add to cart (desktop) ---------- */
  // Slides up once the main button has scrolled under the fixed nav. Its button submits the main form, and
  // copies the main button's text and disabled state, so stock, errors and "View cart" behave the same.
  var sticky = root.querySelector('[data-pdp-sticky-atc]');
  var stickyBtn = sticky && sticky.querySelector('[data-pdp-sticky-add]');
  var stickyVariant = sticky && sticky.querySelector('[data-pdp-sticky-variant]');
  var stickyImg = sticky && sticky.querySelector('.pdp-sticky__img');
  var stickyImgDefault = stickyImg && stickyImg.getAttribute('src');
  var stickyError = sticky && sticky.querySelector('[data-pdp-sticky-error]');
  var NAV_HEIGHT = 58;

  function syncSticky() {
    stickyBtn.textContent = addBtn.textContent;
    stickyBtn.disabled = addBtn.disabled;
    stickyBtn.classList.toggle('addedCart', addBtn.classList.contains('addedCart'));
  }

  function updateStickyVariant(options, variant) {
    if (stickyVariant) stickyVariant.textContent = options.filter(Boolean).join(' / ');
    var image = (variant && variant.image) || stickyImgDefault;
    if (stickyImg && image) {
      stickyImg.removeAttribute('srcset');
      stickyImg.src = image;
    }
  }

  if (sticky && stickyBtn) {
    new MutationObserver(syncSticky).observe(addBtn, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, characterData: true, subtree: true });
    syncSticky();
    // Read on scroll rather than with an IntersectionObserver: a jump from "button below the screen" straight
    // to "button above it" (End key, the reviews link on a short screen) never crosses the edge, so an
    // observer would not fire. Hidden again over the footer, as on revitsport.com.
    var footer = document.getElementById('shopify-section-footer');
    var stickyTicking = false;
    function showSticky() {
      stickyTicking = false;
      if (mobile.matches) return; // the bar is desktop only (display: none below 992px)
      var passedButton = addBtn.getBoundingClientRect().bottom < NAV_HEIGHT;
      var footerInView = footer && footer.getBoundingClientRect().top < window.innerHeight;
      sticky.classList.toggle('is-visible', passedButton && !footerInView);
    }
    function queueSticky() {
      if (stickyTicking) return;
      stickyTicking = true;
      window.requestAnimationFrame(showSticky);
    }
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky, { passive: true });
    showSticky();

    var change = sticky.querySelector('[data-pdp-sticky-change]');
    if (change) {
      change.addEventListener('click', function (event) {
        event.preventDefault();
        var top = root.getBoundingClientRect().top + window.pageYOffset - NAV_HEIGHT;
        window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        var first = form.querySelector('.pdp-option__values:not([hidden]) input:checked') || addBtn;
        first.focus({ preventScroll: true });
      });
    }
  }

  var dealer = root.querySelector('[data-pdp-dealer]');
  if (dealer) {
    dealer.addEventListener('click', function () {
      if (typeof window.ga === 'function') window.ga('send', 'event', 'Find a Dealer', 'Click', dealer.dataset.title);
    });
  }

  /* ---------- Back-in-stock (Klaviyo) ---------- */

  var notifyForm = notify && notify.querySelector('[data-pdp-notify-form]');
  var notifyLabel = notify && notify.querySelector('[data-pdp-notify-label]');
  var notifyLabelText = notifyLabel ? notifyLabel.textContent : '';
  var notifyDoneFor = null; // variant id of the last successful signup

  // After a signup the form is hidden; picking another sold-out variant brings it back for that variant.
  function resetNotify() {
    notifyDoneFor = null;
    notifyForm.hidden = false;
    notifyForm.querySelector('button[type="submit"]').disabled = false;
    if (notifyLabel) notifyLabel.textContent = notifyLabelText;
  }

  if (notifyForm) {
    notifyForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = notifyForm.elements.email.value;
      var submitBtn = notifyForm.querySelector('button[type="submit"]');
      var label = notify.querySelector('[data-pdp-notify-label]');
      submitBtn.disabled = true;
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Va4H5j', {
        method: 'POST',
        headers: { accept: 'application/json', revision: '2025-04-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + idInput.value } }
            }
          }
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          notifyForm.hidden = true;
          notifyDoneFor = String(idInput.value);
          label.textContent = 'Thank you! We will send you an email once the product becomes available.';
        })
        .catch(function (error) {
          console.error('Back-in-stock signup failed', error);
          submitBtn.disabled = false;
          label.textContent = 'Sorry, that didn’t work. Please check your email and try again.';
        });
    });
  }

  /* ---------- Accordions ---------- */
  // Open/close with a height animation and keep the clicked heading exactly where it is on screen.
  // While animating, the sticky column is pinned at its current position (position: relative with the
  // same offset), so neither the sticky offset nor the scroll changes. Afterwards the sticky is restored
  // and the scroll corrected in the same task, before the browser paints, so nothing visibly jumps.
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pinColumn(column) {
    if (!column || getComputedStyle(column).position !== 'sticky') return false;
    var shown = column.getBoundingClientRect().top;
    column.style.position = 'relative';
    column.style.top = '0px';
    column.style.top = (shown - column.getBoundingClientRect().top) + 'px';
    return true;
  }

  function holdPosition(heading, top) {
    // Scrolling also changes how sticky columns resolve, so repeat until settled.
    for (var i = 0; i < 4; i++) {
      var drift = heading.getBoundingClientRect().top - top;
      if (Math.abs(drift) <= 0.5) return;
      window.scrollBy(0, drift);
    }
  }

  root.querySelectorAll('details.pdp-acc').forEach(function (details) {
    var summary = details.querySelector('summary');
    var body = details.querySelector('.pdp-acc__body');
    if (!summary || !body) return;

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (details.dataset.animating) return;

      var opening = !details.open;
      var top = summary.getBoundingClientRect().top;
      var column = summary.closest('[data-pdp-sticky]');
      var pinned = pinColumn(column);
      details.dataset.animating = 'true';
      if (opening) details.open = true;

      var closed = { height: '0px', paddingBottom: '0px' };
      var open = { height: body.offsetHeight + 'px', paddingBottom: getComputedStyle(body).paddingBottom };
      body.style.overflow = 'hidden';
      var animation = body.animate(opening ? [closed, open] : [open, closed], {
        duration: reduceMotion.matches ? 0 : 300,
        easing: 'cubic-bezier(.4, 0, .2, 1)'
      });

      animation.onfinish = animation.oncancel = function () {
        if (!opening) details.open = false;
        body.style.overflow = '';
        delete details.dataset.animating;
        if (pinned) {
          column.style.position = '';
          column.style.top = '';
          updateSticky();
        }
        holdPosition(summary, top);
      };
    });
  });

  /* ---------- Description images ---------- */
  // Lazy in the HTML so they don't compete with the lead image. A closed accordion never triggers lazy
  // loading, so fetch them once the page has loaded: they are then sized and ready when it opens.
  function loadAccordionImages() {
    root.querySelectorAll('[data-pdp-description] img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }

  if (document.readyState === 'complete') loadAccordionImages();
  else window.addEventListener('load', loadAccordionImages, { once: true });

  /* ---------- "View all specs and features" ---------- */
  // Smooth scroll to the Extra Information section instead of jumping (it has scroll-margin-top for the menu).
  var specsLink = root.querySelector('.pdp-specs-link');
  if (specsLink) {
    specsLink.addEventListener('click', function (event) {
      var target = document.getElementById('extra-information');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) window.history.replaceState(window.history.state, '', '#extra-information');
    });
  }

  /* ---------- Scroll freeze (desktop) ---------- */
  // Each column sticks at the header offset, or at its own bottom edge if it is taller than
  // the viewport — so whichever column runs out first holds while the other keeps scrolling.

  var stickies = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-sticky]'));
  var STICKY_OFFSET = 78; // fixed nav bar (58px) + 20px breathing room
  var BOTTOM_GAP = 20;

  function updateSticky() {
    var viewport = window.innerHeight;
    stickies.forEach(function (column) {
      var top = Math.min(STICKY_OFFSET, viewport - column.offsetHeight - BOTTOM_GAP);
      column.style.setProperty('--pdp-sticky-top', top + 'px');
    });
  }

  if (stickies.length) {
    updateSticky();
    window.addEventListener('resize', updateSticky, { passive: true });
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(updateSticky);
      stickies.forEach(function (column) { observer.observe(column); });
    }
  }

  update(false);
})();
